import * as SplashScreen from 'expo-splash-screen';
import React, { StrictMode } from 'react';
import { LogBox } from 'react-native';
import { KeyboardProvider } from 'react-native-keyboard-controller';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { ErrorBoundary } from '@components/ErrorBoundary';
import { AppNavigationContainer } from '@components/NavigationContainer';
import { AuthenticationProvider } from '@context/AuthContext';
import { AppPaperProvider, ThemeProvider, useStatusBarTheme } from '@context/ThemeContext';
import { ActionSheetProvider } from '@expo/react-native-action-sheet';
import Constants from '@helpers/Constants';
import { setExceptionHandlers } from '@helpers/Errors';
import { logError, logInfo } from '@helpers/Loggers';
import { RuntimeConfig } from '@helpers/RuntimeConfig';
import { initSentry, wrapSentry } from '@helpers/Sentry';
import { AppQueryProvider } from '@helpers/query';
import AppStack from '@navigation/AppStack';

SplashScreen.preventAutoHideAsync().catch((error) => logError(error));

SplashScreen.setOptions({
  duration: 1000,
  fade: true,
});

initSentry();
setExceptionHandlers();

if (RuntimeConfig.isE2E) {
  LogBox.ignoreAllLogs();
}

logInfo('JSENV: ' + Constants.joinstar.JSENV);
logInfo('JSEMULATE: ' + Constants.joinstar.JSEMULATE);
logInfo('JSE2E: ' + Constants.joinstar.JSE2E);

function App() {
  return (
    <StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <InnerApp />
        </ThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}

function InnerApp() {
  useStatusBarTheme();

  return (
    <AppPaperProvider>
      <AppQueryProvider>
        <ActionSheetProvider>
          <SafeAreaProvider>
            <KeyboardProvider>
              {/*
              Note: we provide this second error boundary within
              the theme/provider contexts to get proper theme/format
              */}
              <ErrorBoundary>
                <AuthenticationProvider>
                  <AppNavigationContainer>
                    <AppStack />
                  </AppNavigationContainer>
                </AuthenticationProvider>
              </ErrorBoundary>
            </KeyboardProvider>
          </SafeAreaProvider>
        </ActionSheetProvider>
      </AppQueryProvider>
    </AppPaperProvider>
  );
}

export default wrapSentry(App);
